// hover working stop
function initTabSliders() {
    const tabButtons = document.querySelectorAll('.bes-tab-button');
    
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabId = this.getAttribute('data-tab');
            const tabPane = document.getElementById(tabId);
            
            // Initialize slider for the newly active tab
            if (tabPane) {
                const slider = tabPane.querySelector('.cps-slider');
                if (slider && !slider._initialized) {
                    initProductSlider(slider);
                    slider._initialized = true;
                }
            }
        });
    });
    
    // Initialize the first visible tab
    const initialTab = document.querySelector('.bes-tab-pane.bes-active');
    if (initialTab) {
        const slider = initialTab.querySelector('.cps-slider');
        if (slider) {
            initProductSlider(slider);
            slider._initialized = true;
        }
    }
}
function initProductSlider(slider) {
    const infoPanelId = slider.id + '-info';
    const infoPanel = document.getElementById(infoPanelId);
    const container = slider.closest('.cps-slider-container');
    
    if (!infoPanel) return;

    let hoverTimeout;
    let autoScrollInterval;
    const autoScrollDelay = 5000;
    let isMouseOverInfoArea = false;
    let currentHoveredCard = null;

    function startAutoScroll() {
        if (!autoScrollInterval && !isMouseOverInfoArea) {
            autoScrollInterval = setInterval(() => scrollSlider('next'), autoScrollDelay);
        }
    }

    function stopAutoScroll() {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
    }

    function isMouseInInfoArea(element) {
        return element && (
            element.closest('.cps-extra-info-panel') === infoPanel ||
            element.classList.contains('spec-section') ||
            element.closest('.spec-section')
        );
    }

    function showInfoPanel(card) {
        stopAutoScroll();
        clearTimeout(hoverTimeout);
        isMouseOverInfoArea = true;
        currentHoveredCard = card;
        
        const info = card.getAttribute('data-extra');
        const cardRect = card.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        infoPanel.style.left = `${cardRect.left - containerRect.left}px`;
        infoPanel.style.width = `${card.offsetWidth}px`;
        infoPanel.innerHTML = info;
        infoPanel.style.display = 'block';
    }

    function hideInfoPanel() {
        isMouseOverInfoArea = false;
        currentHoveredCard = null;
        infoPanel.style.display = 'none';
        startAutoScroll();
    }

    function scheduleHideInfoPanel(delay = 150) {
        hoverTimeout = setTimeout(() => {
            if (!isMouseOverInfoArea) {
                hideInfoPanel();
            }
        }, delay);
    }

    // Product card events
    slider.querySelectorAll('.cps-product-card').forEach(card => {
        card.addEventListener('mouseenter', () => showInfoPanel(card));
        
        card.addEventListener('mouseleave', (e) => {
            if (isMouseInInfoArea(e.relatedTarget)) {
                return; // Don't hide if moving to info area
            }
            isMouseOverInfoArea = false;
            scheduleHideInfoPanel();
        });
    });

    // Info panel events with proper spec-section handling
    if (infoPanel) {
        infoPanel.addEventListener('mouseenter', () => {
            isMouseOverInfoArea = true;
            stopAutoScroll();
            clearTimeout(hoverTimeout);
        });

        infoPanel.addEventListener('mouseleave', (e) => {
            if (currentHoveredCard && e.relatedTarget === currentHoveredCard) {
                return; // Don't hide if moving back to card
            }
            
            if (isMouseInInfoArea(e.relatedTarget)) {
                return; // Don't hide if moving to spec sections
            }
            
            isMouseOverInfoArea = false;
            scheduleHideInfoPanel();
        });

        // Handle spec sections with event delegation
        infoPanel.addEventListener('mouseover', (e) => {
            if (e.target.closest('.spec-section')) {
                isMouseOverInfoArea = true;
                stopAutoScroll();
                clearTimeout(hoverTimeout);
            }
        });

        infoPanel.addEventListener('mouseout', (e) => {
            const specSection = e.target.closest('.spec-section');
            if (specSection && !isMouseInInfoArea(e.relatedTarget)) {
                isMouseOverInfoArea = false;
                scheduleHideInfoPanel();
            }
        });
    }

    // Navigation and scrolling
    const wrapper = slider.closest('.cps-slider-wrapper');
    const prevBtn = wrapper?.querySelector('.cps-nav-left');
    const nextBtn = wrapper?.querySelector('.cps-nav-right');

    function getScrollAmount() {
        const firstCard = slider.querySelector('.cps-product-card');
        if (!firstCard) return slider.offsetWidth;
        return firstCard.offsetWidth + parseInt(window.getComputedStyle(slider).gap);
    }

    function scrollSlider(direction) {
        const scrollAmount = getScrollAmount();
        let targetScroll = slider.scrollLeft + (direction === 'next' ? scrollAmount : -scrollAmount);
        if (direction === 'next' && targetScroll + slider.offsetWidth >= slider.scrollWidth - 50) {
            targetScroll = 0;
        }
        slider.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    prevBtn?.addEventListener('click', () => {
        stopAutoScroll();
        scrollSlider('prev');
        startAutoScroll();
    });
    
    nextBtn?.addEventListener('click', () => {
        stopAutoScroll();
        scrollSlider('next');
        startAutoScroll();
    });

    // Touch support
    slider.addEventListener('touchstart', stopAutoScroll);
    slider.addEventListener('touchend', startAutoScroll);
    
    startAutoScroll();
}

// Rest of your existing code remains the same...
function initTabSliders() {
    const tabButtons = document.querySelectorAll('.bes-tab-button');
    
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabId = this.getAttribute('data-tab');
            const tabPane = document.getElementById(tabId);
            
            // Initialize slider for the newly active tab
            if (tabPane) {
                const slider = tabPane.querySelector('.cps-slider');
                if (slider && !slider._initialized) {
                    initProductSlider(slider);
                    slider._initialized = true;
                }
            }
        });
    });
    
    // Initialize the first visible tab
    const initialTab = document.querySelector('.bes-tab-pane.bes-active');
    if (initialTab) {
        const slider = initialTab.querySelector('.cps-slider');
        if (slider) {
            initProductSlider(slider);
            slider._initialized = true;
        }
    }
}

function initProductSlider(sliderId, infoPanelId) {
    const slider = document.getElementById(sliderId);
    const container = slider?.closest('.cps-slider-container');
    const infoPanel = document.getElementById(infoPanelId);
    
    if (!slider || !container) return;
    
    if (!infoPanel) return;

    let hoverTimeout;

    slider.querySelectorAll('.cps-product-card').forEach(card => {
        card.addEventListener('mouseenter', function() {
            stopAutoScroll();
            clearTimeout(hoverTimeout);
            const info = this.getAttribute('data-extra');
            const cardRect = this.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            infoPanel.style.left = `${cardRect.left - containerRect.left}px`;
            infoPanel.style.width = `${this.offsetWidth}px`;
            infoPanel.innerHTML = info;
            infoPanel.style.display = 'block';
        });

        card.addEventListener('mouseleave', function(e) {
            const relatedTarget = e.relatedTarget;
            // Check if moving to info panel or spec sections
            if (relatedTarget && (relatedTarget.closest('.cps-extra-info-panel') === infoPanel || relatedTarget.closest('.spec-section'))) return;
            hoverTimeout = setTimeout(() => {
                infoPanel.style.display = 'none';
                startAutoScroll();
            }, 150);
        });
    });

    infoPanel?.addEventListener('mouseenter', () => {
        stopAutoScroll();
        clearTimeout(hoverTimeout);
    });

    infoPanel?.addEventListener('mouseleave', function(e) {
        const relatedTarget = e.relatedTarget;
        // Check if moving back to product card or staying within spec sections
        if (!relatedTarget || !(relatedTarget.closest('.cps-product-card') || relatedTarget.closest('.spec-section'))) {
            infoPanel.style.display = 'none';
            startAutoScroll();
        }
    });

    // Handle spec sections inside info panel
    infoPanel?.addEventListener('mouseover', (e) => {
        if (e.target.closest('.spec-section')) {
            clearTimeout(hoverTimeout);
            stopAutoScroll();
        }
    });
    
    // Initialize slider navigation functionality
    const wrapper = slider.closest('.cps-slider-wrapper');
    const prevBtn = wrapper?.querySelector('.cps-nav-left');
    const nextBtn = wrapper?.querySelector('.cps-nav-right');

    function getScrollAmount() {
        const firstCard = slider.querySelector('.cps-product-card');
        if (!firstCard) return slider.offsetWidth;
        return firstCard.offsetWidth + parseInt(window.getComputedStyle(slider).gap);
    }

    function scrollSlider(direction) {
        const scrollAmount = getScrollAmount();
        let targetScroll = slider.scrollLeft + (direction === 'next' ? scrollAmount : -scrollAmount);
        if (direction === 'next' && targetScroll + slider.offsetWidth >= slider.scrollWidth - 50) {
            targetScroll = 0;
        }
        slider.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    prevBtn?.addEventListener('click', () => scrollSlider('prev'));
    nextBtn?.addEventListener('click', () => scrollSlider('next'));

    let autoScrollInterval;
    const autoScrollDelay = 5000;

    function startAutoScroll() {
        autoScrollInterval = setInterval(() => scrollSlider('next'), autoScrollDelay);
    }

    function stopAutoScroll() {
        clearInterval(autoScrollInterval);
    }

    // Stop auto-scroll when hovering over slider
    slider.addEventListener('mouseenter', stopAutoScroll);
    slider.addEventListener('mouseleave', startAutoScroll);
    slider.addEventListener('touchstart', stopAutoScroll);
    slider.addEventListener('touchend', startAutoScroll);

    // Stop auto-scroll when hovering over info panel (meta fields)
    infoPanel.addEventListener('mouseenter', stopAutoScroll);
    infoPanel.addEventListener('mouseleave', startAutoScroll);

    startAutoScroll();
}
function configureMobileSlider() {
    const mobileSlider = document.getElementById('cps-productSlider-mobile');
    if (!mobileSlider) return;
    
    // Only modify on desktop (≥1024px)
    if (window.innerWidth >= 1024) {
        const sliderWidth = mobileSlider.offsetWidth;
        const gap = 15; // Match your existing gap
        const slideWidth = (sliderWidth - (3 * gap)) / 4;
        
        // Apply to each slide
        mobileSlider.querySelectorAll('.cps-slide').forEach(slide => {
            slide.style.minWidth = `${slideWidth}px`;
            slide.style.flex = `0 0 ${slideWidth}px`;
        });
        
        // Ensure proper alignment
        mobileSlider.style.justifyContent = 'flex-start';
        mobileSlider.style.overflowX = 'auto';
        mobileSlider.style.scrollSnapType = 'x mandatory';
    }
}

// ========== MAIN SLIDER INITIALIZATION ==========
document.addEventListener('DOMContentLoaded', function() {
  const productSliders = [
    { id: 'cps-productSlider1', infoPanel: 'cps-extraInfo1' },
    { id: 'cps-productSlider2', infoPanel: 'cps-extraInfo2' },
    { id: 'cps-productSlider3', infoPanel: 'cps-extraInfo3' },
    { id: 'cps-productSlider4', infoPanel: 'cps-extraInfo4' },
    { id: 'cps-productSlider5', infoPanel: 'cps-extraInfo5' },
    { id: 'cps-productSlider6', infoPanel: 'cps-extraInfo6' },
    { id: 'cps-productSlider7', infoPanel: 'cps-extraInfo7' },
    { id: 'cps-productSlider8', infoPanel: 'cps-extraInfo8' },
    { id: 'cps-productSlider9', infoPanel: 'cps-extraInfo9' },
    { id: 'cps-productSlider10', infoPanel: 'cps-extraInfo10' },
    { id: 'cps-productSlider11', infoPanel: 'cps-extraInfo11' },
    { id: 'cps-productSlider12', infoPanel: 'cps-extraInfo12' },
    { id: 'cps-productSlider13', infoPanel: 'cps-extraInfo13' },
    { id: 'cps-productSlider14', infoPanel: 'cps-extraInfo14' },
    { id: 'cps-productSlider15', infoPanel: 'cps-extraInfo15' },
    { id: 'cps-productSlider16', infoPanel: 'cps-extraInfo16' },
    { id: 'cps-productSlider17', infoPanel: 'cps-extraInfo17' },
    { id: 'cps-productSlider18', infoPanel: 'cps-extraInfo18' },
    { id: 'cps-productSlider19', infoPanel: 'cps-extraInfo19' },
    { id: 'cps-productSlider20', infoPanel: 'cps-extraInfo20' },
    { id: 'cps-productSlider21', infoPanel: 'cps-extraInfo21' },
    { id: 'cps-productSlider22', infoPanel: 'cps-extraInfo22' },
    { id: 'cps-productSlider23', infoPanel: 'cps-extraInfo23' },
    { id: 'cps-productSlider24', infoPanel: 'cps-extraInfo24' },
    { id: 'cps-productSlider25', infoPanel: 'cps-extraInfo25' },
    { id: 'cps-productSlider26', infoPanel: 'cps-extraInfo26' },
    { id: 'cps-productSlider27', infoPanel: 'cps-extraInfo27' },
    { id: 'cps-productSlider28', infoPanel: 'cps-extraInfo28' },
    { id: 'cps-productSlider29', infoPanel: 'cps-extraInfo29' },
    { id: 'cps-productSlider30', infoPanel: 'cps-extraInfo30' },
    { id: 'cps-productSlider31', infoPanel: 'cps-extraInfo31' },
    { id: 'cps-productSlider32', infoPanel: 'cps-extraInfo32' },
    { id: 'cps-productSlider33', infoPanel: 'cps-extraInfo33' },
    { id: 'cps-productSlider34', infoPanel: 'cps-extraInfo34' },
    { id: 'cps-productSlider35', infoPanel: 'cps-extraInfo35' },
    { id: 'cps-productSlider36', infoPanel: 'cps-extraInfo36' },
    { id: 'cps-productSlider37', infoPanel: 'cps-extraInfo37' },
    { id: 'cps-productSlider38', infoPanel: 'cps-extraInfo38' },
    { id: 'cps-productSlider39', infoPanel: 'cps-extraInfo39' },
    { id: 'cps-productSlider40', infoPanel: 'cps-extraInfo40' },
    { id: 'cps-productSlider41', infoPanel: 'cps-extraInfo41' },
    { id: 'cps-productSlider42', infoPanel: 'cps-extraInfo42' },
    { id: 'cps-productSlider43', infoPanel: 'cps-extraInfo43' },
    { id: 'cps-productSlider44', infoPanel: 'cps-extraInfo44' },
    { id: 'cps-productSlider45', infoPanel: 'cps-extraInfo45' },
    { id: 'cps-productSlider46', infoPanel: 'cps-extraInfo46' },
    { id: 'cps-productSlider47', infoPanel: 'cps-extraInfo47' },
    { id: 'cps-productSlider48', infoPanel: 'cps-extraInfo48' },
    { id: 'cps-productSlider49', infoPanel: 'cps-extraInfo49' },
    { id: 'cps-productSlider50', infoPanel: 'cps-extraInfo50' },
    { id: 'cps-productSlider51', infoPanel: 'cps-extraInfo51' },
    { id: 'cps-productSlider52', infoPanel: 'cps-extraInfo52' },
    { id: 'cps-productSlider53', infoPanel: 'cps-extraInfo53' },
    { id: 'cps-productSlider54', infoPanel: 'cps-extraInfo54' },
    { id: 'cps-productSlider55', infoPanel: 'cps-extraInfo55' },
    { id: 'cps-productSlider56', infoPanel: 'cps-extraInfo56' },
    { id: 'cps-productSlider57', infoPanel: 'cps-extraInfo57' },
    { id: 'cps-productSlider58', infoPanel: 'cps-extraInfo58' },
    { id: 'cps-productSlider59', infoPanel: 'cps-extraInfo59' },
    { id: 'cps-productSlider60', infoPanel: 'cps-extraInfo60' },
    { id: 'cps-productSlider61', infoPanel: 'cps-extraInfo61' },
    { id: 'cps-productSlider62', infoPanel: 'cps-extraInfo62' },
    { id: 'cps-productSlider63', infoPanel: 'cps-extraInfo63' },
    { id: 'cps-productSlider64', infoPanel: 'cps-extraInfo64' },
    { id: 'cps-productSlider65', infoPanel: 'cps-extraInfo65' },
    { id: 'cps-productSlider66', infoPanel: 'cps-extraInfo66' },
    { id: 'cps-productSlider67', infoPanel: 'cps-extraInfo67' },
    { id: 'cps-productSlider68', infoPanel: 'cps-extraInfo68' },
    { id: 'cps-productSlider69', infoPanel: 'cps-extraInfo69' },
    { id: 'cps-productSlider70', infoPanel: 'cps-extraInfo70' },
    { id: 'cps-productSlider71', infoPanel: 'cps-extraInfo71' },
    { id: 'cps-productSlider72', infoPanel: 'cps-extraInfo72' },
    { id: 'cps-productSlider73', infoPanel: 'cps-extraInfo73' },
    { id: 'cps-productSlider74', infoPanel: 'cps-extraInfo74' },
    { id: 'cps-productSlider75', infoPanel: 'cps-extraInfo75' },
    { id: 'cps-productSlider76', infoPanel: 'cps-extraInfo76' },
    { id: 'cps-productSlider77', infoPanel: 'cps-extraInfo77' },
    { id: 'cps-productSlider78', infoPanel: 'cps-extraInfo78' },
    { id: 'cps-productSlider79', infoPanel: 'cps-extraInfo79' },
    { id: 'cps-productSlider80', infoPanel: 'cps-extraInfo80' },
    { id: 'cps-productSlider81', infoPanel: 'cps-extraInfo81' },
    { id: 'cps-productSlider82', infoPanel: 'cps-extraInfo82' },
    { id: 'cps-productSlider83', infoPanel: 'cps-extraInfo83' },
    { id: 'cps-productSlider84', infoPanel: 'cps-extraInfo84' },
    { id: 'cps-productSlider85', infoPanel: 'cps-extraInfo85' },
    { id: 'cps-productSlider86', infoPanel: 'cps-extraInfo86' },
    { id: 'cps-productSlider87', infoPanel: 'cps-extraInfo87' },
    { id: 'cps-productSlider100', infoPanel: 'cps-extraInfo100' },
    { id: 'cps-productSlider-mobile', infoPanel: 'cps-extraInfo-mobile' },
    { id: 'cps-productSlider-mobile-phones', infoPanel: 'cps-extraInfo-mobile-phones' },
    { id: 'cps-productSlider-ipads', infoPanel: 'cps-extraInfo-ipads' },
    { id: 'cps-productSlider-related', infoPanel: 'cps-extraInfo-related' },
    { id: 'cps-productSlider-ipads-tablet', infoPanel: 'cps-extraInfo-ipads' },
    { id: 'cps-productSlider-sale', infoPanel: 'cps-productSlider-sale-info' },
    { id: 'cps-productSlider-wearable', infoPanel: 'cps-extraInfo-wearable' },
    { id: 'cps-productSlider-games', infoPanel: 'cps-extraInfo-games' }, 
    { id: 'cps-productSlider-speakers', infoPanel: 'cps-extraInfo-speakers' },
  ];

  const brandSliders = [
    'cps-poco-slider',
    'cps-sparx-slider',
    'cps-motorola-slider',
    'cps-nokia-slider',
    'cps-redmi-slider',
    'cps-dcode-slider',
  ];

  productSliders.forEach(sliderConfig => {
  const slider = document.getElementById(sliderConfig.id);
  if (!slider) return;

  const infoPanel = document.getElementById(sliderConfig.infoPanel);
  const container = slider.closest('.cps-slider-container');
  const wrapper = slider.closest('.cps-slider-wrapper');
  const prevBtn = wrapper?.querySelector('.cps-nav-left');
  const nextBtn = wrapper?.querySelector('.cps-nav-right');

  let hoverTimeout;
  let isMouseOverInfoArea = false; // State management flag
  let currentHoveredCard = null;

  function getScrollAmount() {
    const firstCard = slider.querySelector('.cps-product-card');
    if (!firstCard) return slider.offsetWidth;
    return firstCard.offsetWidth + parseInt(window.getComputedStyle(slider).gap);
  }

  // Simplified and reliable hover detection
  function isMouseInInfoArea(element) {
    return element && (
      element.closest('.cps-extra-info-panel') === infoPanel ||
      element.classList.contains('spec-section') ||
      element.closest('.spec-section')
    );
  }

  function showInfoPanel(card) {
    stopAutoScroll();
    clearTimeout(hoverTimeout);
    isMouseOverInfoArea = true;
    currentHoveredCard = card;
    
    const info = card.getAttribute('data-extra');
    const cardRect = card.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    
    infoPanel.style.left = `${cardRect.left - containerRect.left}px`;
    infoPanel.style.width = `${card.offsetWidth}px`;
    infoPanel.innerHTML = info;
    infoPanel.style.display = 'block';
  }

  function hideInfoPanel() {
    isMouseOverInfoArea = false;
    currentHoveredCard = null;
    infoPanel.style.display = 'none';
    startAutoScroll();
  }

  function scheduleHideInfoPanel(delay = 150) {
    hoverTimeout = setTimeout(() => {
      if (!isMouseOverInfoArea) {
        hideInfoPanel();
      }
    }, delay);
  }

  // Product card event handlers
  slider.querySelectorAll('.cps-product-card').forEach(card => {
    card.addEventListener('mouseenter', function() {
      showInfoPanel(this);
    });

    card.addEventListener('mouseleave', function(e) {
      // Check if mouse is moving to info panel area
      if (isMouseInInfoArea(e.relatedTarget)) {
        return; // Don't hide if moving to info area
      }
      
      isMouseOverInfoArea = false;
      scheduleHideInfoPanel();
    });
  });

  // Info panel event handlers with proper state management
  if (infoPanel) {
    infoPanel.addEventListener('mouseenter', () => {
      isMouseOverInfoArea = true;
      stopAutoScroll();
      clearTimeout(hoverTimeout);
    });

    infoPanel.addEventListener('mouseleave', (e) => {
      // Check if mouse is moving back to the current hovered card
      if (currentHoveredCard && e.relatedTarget === currentHoveredCard) {
        return; // Don't hide if moving back to card
      }
      
      // Check if mouse is still in info area (spec sections)
      if (isMouseInInfoArea(e.relatedTarget)) {
        return; // Don't hide if moving to spec sections
      }
      
      isMouseOverInfoArea = false;
      scheduleHideInfoPanel();
    });

    // Handle dynamically added spec sections with event delegation
    infoPanel.addEventListener('mouseover', (e) => {
      if (e.target.closest('.spec-section')) {
        isMouseOverInfoArea = true;
        stopAutoScroll();
        clearTimeout(hoverTimeout);
      }
    });

    infoPanel.addEventListener('mouseout', (e) => {
      const specSection = e.target.closest('.spec-section');
      if (specSection) {
        // Only schedule hide if mouse is leaving the entire info area
        if (!isMouseInInfoArea(e.relatedTarget)) {
          isMouseOverInfoArea = false;
          scheduleHideInfoPanel();
        }
      }
    });
  }

    function scrollSlider(direction) {
      const scrollAmount = getScrollAmount();
      let targetScroll = slider.scrollLeft + (direction === 'next' ? scrollAmount : -scrollAmount);
      if (direction === 'next' && targetScroll + slider.offsetWidth >= slider.scrollWidth - 50) {
        targetScroll = 0;
      }
      slider.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    prevBtn?.addEventListener('click', () => scrollSlider('prev'));
    nextBtn?.addEventListener('click', () => scrollSlider('next'));

    let isDragging = false, startX, scrollLeft;
    slider.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.touches[0].pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 2;
    });

    let autoScrollInterval;
    const autoScrollDelay = 5000;

    function startAutoScroll() {
      autoScrollInterval = setInterval(() => scrollSlider('next'), autoScrollDelay);
    }

    function stopAutoScroll() {
      clearInterval(autoScrollInterval);
    }

    slider.addEventListener('mouseenter', stopAutoScroll);
    slider.addEventListener('mouseleave', startAutoScroll);
    slider.addEventListener('touchstart', stopAutoScroll);
    slider.addEventListener('touchend', startAutoScroll);

    startAutoScroll();
  });
  class BrandSlider {
    constructor(sliderId) {
      this.slider = document.getElementById(sliderId);
      if (!this.slider) {
        console.log('Slider element not found:', sliderId);
        return;
      }

      this.track = this.slider.querySelector('.cps-slider-track');
      if (!this.track) {
        console.log('Track not found for slider:', sliderId);
        return;
      }

      this.slides = Array.from(this.track.children);
      console.log(`Found ${this.slides.length} slides for ${sliderId}`);
      
      this.prevBtn = this.slider.closest('.cps-slider-wrapper')?.querySelector('.cps-nav-left');
      this.nextBtn = this.slider.closest('.cps-slider-wrapper')?.querySelector('.cps-nav-right');

      this.currentIndex = 0;
      this.slidesPerView = this.getSlidesPerView();
      this.isAnimating = false;
      this.autoPlayInterval = null;
      this.autoPlayDelay = 5000;

      this.init();
    }

    getSlidesPerView() {
      const width = window.innerWidth;
      if (width <= 480) return 1;
      if (width <= 768) return 1;
      return 2;
    }

    init() {
      this.setupSlides();
      this.setupEventListeners();
      this.startAutoPlay();
      this.updateSliderPosition();
    }

    setupSlides() {
      // Remove any existing clones
      this.track.querySelectorAll('.cps-slide.clone').forEach(clone => clone.remove());
      
      // Get original slides (excluding clones)
      this.slides = Array.from(this.track.children).filter(slide => !slide.classList.contains('clone'));
      
      if (this.slides.length === 0) return;
      
      // Calculate slide width accounting for gap (10px margin-right)
      const gap = 10; // 10px gap between slides
      const containerWidth = this.slider.offsetWidth;
      const slideWidth = (containerWidth - gap) / this.slidesPerView;
      const slideWidthPercent = (slideWidth / containerWidth) * 100;
      
      // Set width for all original slides
      this.slides.forEach(slide => {
        slide.style.flex = `0 0 ${slideWidthPercent}%`;
        slide.style.minWidth = `${slideWidthPercent}%`;
        slide.style.maxWidth = `${slideWidthPercent}%`;
        slide.style.marginRight = `${gap}px`;
      });
      
      // Create clones for infinite loop effect
      const clones = this.slides.slice(0, this.slidesPerView).map(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('clone');
        clone.style.flex = `0 0 ${slideWidthPercent}%`;
        clone.style.minWidth = `${slideWidthPercent}%`;
        clone.style.maxWidth = `${slideWidthPercent}%`;
        clone.style.marginRight = `${gap}px`;
        return clone;
      });
      
      // Add clones to the end
      clones.forEach(clone => this.track.appendChild(clone));
      
      console.log(`Setup complete: ${this.slides.length} original slides, ${clones.length} clones, slideWidth: ${slideWidthPercent}%`);
    }

    setupEventListeners() {
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());
      this.slider.addEventListener('mouseenter', () => this.pauseAutoPlay());
      this.slider.addEventListener('mouseleave', () => this.startAutoPlay());

      window.addEventListener('resize', () => {
        const newSlidesPerView = this.getSlidesPerView();
        if (newSlidesPerView !== this.slidesPerView) {
          this.slidesPerView = newSlidesPerView;
          this.setupSlides();
          this.updateSliderPosition();
        }
      });
    }

    updateSliderPosition() {
      const gap = 10; // 10px gap
      const containerWidth = this.slider.offsetWidth;
      const slideWidth = (containerWidth - gap) / this.slidesPerView;
      const slideWidthPercent = (slideWidth / containerWidth) * 100;
      const gapPercent = (gap / containerWidth) * 100;
      
      const translateX = -(this.currentIndex * (slideWidthPercent + gapPercent));
      this.track.style.transform = `translateX(${translateX}%)`;
      console.log(`Slider position: index=${this.currentIndex}, translateX=${translateX}%, slideWidth: ${slideWidthPercent}%, gap: ${gapPercent}%`);
    }

    next() {
      if (this.isAnimating) return;
      this.isAnimating = true;
      
      const slideWidth = 100 / this.slidesPerView;
      this.track.style.transition = 'transform 0.5s ease-out';
      
      this.currentIndex++;
      this.updateSliderPosition();
      
      // If we've reached the end, loop back to start
      if (this.currentIndex >= this.slides.length) {
        setTimeout(() => {
          this.track.style.transition = 'none';
          this.currentIndex = 0;
          this.updateSliderPosition();
          void this.track.offsetWidth; // Force reflow
          this.track.style.transition = 'transform 0.5s ease-out';
          this.isAnimating = false;
        }, 500);
      } else {
        setTimeout(() => this.isAnimating = false, 500);
      }
      
      this.resetAutoPlay();
    }

    prev() {
      if (this.isAnimating) return;
      this.isAnimating = true;
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.slides.length - 1;
        this.track.style.transition = 'none';
        this.updateSliderPosition();
        setTimeout(() => {
          this.track.style.transition = 'transform 0.5s ease-out';
          this.currentIndex--;
          this.updateSliderPosition();
          setTimeout(() => this.isAnimating = false, 500);
        }, 50);
      } else {
        setTimeout(() => this.isAnimating = false, 500);
      }
      this.updateSliderPosition();
      this.resetAutoPlay();
    }

    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => this.next(), this.autoPlayDelay);
    }

    pauseAutoPlay() {
      clearInterval(this.autoPlayInterval);
    }

    resetAutoPlay() {
      this.pauseAutoPlay();
      this.startAutoPlay();
    }
  }

  setTimeout(() => {
    brandSliders.forEach(sliderId => {
      const sliderEl = document.getElementById(sliderId);
      if (sliderEl) {
        console.log('Initializing BrandSlider for:', sliderId);
        new BrandSlider(sliderId);
      } else {
        console.log('Slider element not found:', sliderId);
      }
    });
  }, 100);


  window.addEventListener('resize', handleMobileView);
   function initProductFunctionality() {
    function updateCartNavbar() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          document.querySelectorAll('.cart-badge').forEach(el => el.textContent = cart.item_count);
          document.querySelectorAll('.cart-text').forEach(el => el.textContent = 'Rs ' + (cart.total_price/100).toFixed(0));
        })
        .catch(err => console.error('Error updating cart:', err));
    }

    function openQuickView(product) {
      document.getElementById('quickViewImage').src = product.image;
      document.getElementById('quickViewTitle').textContent = product.title;
      document.getElementById('quickViewPrice').textContent = product.price;
      document.getElementById('quickViewModal').classList.remove('hidden');
    }
    
    function closeQuickView() { 
      document.getElementById('quickViewModal').classList.add('hidden'); 
    }
    
    function addToCart() { 
      alert('Product added to cart!'); 
      closeQuickView(); 
    }

    const RATING_STORAGE_KEY = 'product_rating_data';
    const RATING_VALIDITY_DAYS = 3;
    
    function generateRatingData() {
      const ratings = {};
      document.querySelectorAll('.rating').forEach((el,i) => ratings[i] = Math.random()<0.5?4:5);
      const data = { timestamp: Date.now(), ratings };
      localStorage.setItem(RATING_STORAGE_KEY, JSON.stringify(data));
      return data;
    }
    
    function getRatingData() {
      const stored = localStorage.getItem(RATING_STORAGE_KEY);
      if (stored) {
        const data = JSON.parse(stored);
        if (Date.now() - data.timestamp < RATING_VALIDITY_DAYS*24*60*60*1000) return data;
        localStorage.removeItem(RATING_STORAGE_KEY);
      }
      return generateRatingData();
    }
    
    function applyRatings() {
      const data = getRatingData();
      document.querySelectorAll('.rating').forEach((el,i) => {
        const stars = el.querySelectorAll('i');
        stars.forEach((star, idx) => star.classList.toggle('fa-solid', idx < data.ratings[i]));
      });
    }

    function initProductCards() {
                document.querySelectorAll('.cps-quick-view-btn').forEach(btn => {
                    btn.addEventListener('click', () => {
                        openQuickView({ 
                            image: btn.dataset.image, 
                            title: btn.dataset.title, 
                            price: btn.dataset.price 
                        });
                    });
                });
      
     document.querySelectorAll('.cps-product-card').forEach(card => {
    const mainImage = card.querySelector('.main-image');
    const zones = card.querySelectorAll('.hover-zone');
    if (!mainImage || !zones.length) return;
    
    const defaultSrc = mainImage.src;
    zones.forEach((zone, i) => zone.addEventListener('mouseenter', () => {
        mainImage.style.opacity = 0;
        setTimeout(() => { 
            mainImage.src = zone.dataset.img; 
            mainImage.style.opacity = 1; 
        }, 200);
        card.querySelectorAll('.cps-tab').forEach(t => t.classList.remove('active'));
        card.querySelectorAll('.cps-tab')[i].classList.add('active');
    }));
    
    card.querySelector('.cps-product-image').addEventListener('mouseleave', () => {
        mainImage.style.opacity = 0;
        setTimeout(() => { 
            mainImage.src = defaultSrc; 
            mainImage.style.opacity = 1; 
        }, 200);
        card.querySelectorAll('.cps-tab').forEach(t => t.classList.remove('active'));
        card.querySelectorAll('.cps-tab')[0].classList.add('active');
    });
});
    }

    function initTooltips() {
      document.querySelectorAll('.share-icon').forEach(icon => {
        const wrapper = icon.closest('.share-tooltip-wrapper');
        wrapper.addEventListener('mouseenter', () => 
          wrapper.querySelector('.share-tooltip').style.display='block');
        wrapper.addEventListener('mouseleave', () => 
          wrapper.querySelector('.share-tooltip').style.display='none');
      });
    }

    function formatAuthorNames() {
      document.querySelectorAll('.author-name').forEach(el => {
        el.textContent = el.textContent.trim().split(' ')[0];
      });
    }

    function setupEventDelegation() {
      document.addEventListener('click', event => {
        const tgt = event.target.closest('span'); 
        if (!tgt) return;
        
        if (tgt.classList.contains('add-to-cart-btn')) {
          fetch('/cart/add.js', { 
            method: 'POST', 
            headers: {'Content-Type': 'application/json'}, 
            body: JSON.stringify({ 
              id: tgt.dataset.variantId, 
              quantity: 1 
            }) 
          })
          .then(r => r.json())
          .then(data => { 
            alert('Added!'); 
            updateCartNavbar(); 
          })
          .catch(e => alert('Error'));
        }
      });
    }

    applyRatings();
    initProductCards();
    initTooltips();
    formatAuthorNames();
    setupEventDelegation();
  }

  function randomizeAllSliders() {
    document.querySelectorAll('.slider-track').forEach(track => {
      const slides = Array.from(track.children);
      if (slides.length <= 1) return;
      
      for (let i = slides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [slides[i], slides[j]] = [slides[j], slides[i]];
      }
      
      track.innerHTML = '';
      slides.forEach(s => track.appendChild(s));
    });
  }

  function initBuyElectroTabs() {
    const section = document.querySelector('.bes-product-slider');
    if (!section) return;

    const buttons = section.querySelectorAll('.bes-tab-button');
    const panes = section.querySelectorAll('.bes-tab-pane');

    buttons.forEach(btn => {
      btn.addEventListener('click', function() {
        const target = this.getAttribute('data-tab');

        buttons.forEach(b => b.classList.remove('bes-active'));
        this.classList.add('bes-active');

        panes.forEach(p => {
          if (p.id === target) {
            p.classList.add('bes-active');
            p.style.display = '';
            const sliderContainer = p.querySelector('.slider-container');
            if (sliderContainer && !sliderContainer._sliderInitialized) {
              new CustomSlider(sliderContainer);
              sliderContainer._sliderInitialized = true;
            }
          } else {
            p.classList.remove('bes-active');
            p.style.display = 'none';
          }
        });
      });
    });
  }

  function initWearablesTabs() {
    const section = document.querySelector('.wearables-slider');
    if (!section) return;

    const buttons = section.querySelectorAll('.tab-button');
    const panes = section.querySelectorAll('.tab-pane');

    buttons.forEach(btn => {
      btn.addEventListener('click', function() {
        const target = this.getAttribute('data-tab');

        buttons.forEach(b => b.classList.remove('active'));
        this.classList.add('active');

        panes.forEach(p => {
          if (p.id === target) {
            p.classList.add('active');
            const sliderContainer = p.querySelector('.slider-container');
            if (sliderContainer && !sliderContainer._sliderInitialized) {
              new CustomSlider(sliderContainer);
              sliderContainer._sliderInitialized = true;
            }
          } else {
            p.classList.remove('active');
          }
        });
      });
    });
  }
});
// All categroy slider
  document.addEventListener('DOMContentLoaded', function () {
    initTabSliders();
    const productSliders = [
      { id: 'cps-productSlider1', infoPanel: 'cps-extraInfo1' },
      { id: 'cps-productSlider2', infoPanel: 'cps-extraInfo2' },
      { id: 'cps-productSlider3', infoPanel: 'cps-extraInfo3' },
      { id: 'cps-productSlider4', infoPanel: 'cps-extraInfo4' },
      { id: 'cps-productSlider5', infoPanel: 'cps-extraInfo5' },
      { id: 'cps-productSlider6', infoPanel: 'cps-extraInfo6' },
      { id: 'cps-productSlider7', infoPanel: 'cps-extraInfo7' },
      { id: 'cps-productSlider8', infoPanel: 'cps-extraInfo8' },
      { id: 'cps-productSlider9', infoPanel: 'cps-extraInfo9' },
      { id: 'cps-productSlider10', infoPanel: 'cps-extraInfo10' },
      { id: 'cps-productSlider11', infoPanel: 'cps-extraInfo11' },
      { id: 'cps-productSlider12', infoPanel: 'cps-extraInfo12' },
      { id: 'cps-productSlider13', infoPanel: 'cps-extraInfo13' },
      { id: 'cps-productSlider14', infoPanel: 'cps-extraInfo14' },
      { id: 'cps-productSlider15', infoPanel: 'cps-extraInfo15' },
      { id: 'cps-productSlider16', infoPanel: 'cps-extraInfo16' },
      { id: 'cps-productSlider17', infoPanel: 'cps-extraInfo17' },
      { id: 'cps-productSlider18', infoPanel: 'cps-extraInfo18' },
      { id: 'cps-productSlider19', infoPanel: 'cps-extraInfo19' },
      { id: 'cps-productSlider20', infoPanel: 'cps-extraInfo20' },
      { id: 'cps-productSlider21', infoPanel: 'cps-extraInfo21' },
      { id: 'cps-productSlider22', infoPanel: 'cps-extraInfo22' },
      { id: 'cps-productSlider23', infoPanel: 'cps-extraInfo23' },
      { id: 'cps-productSlider24', infoPanel: 'cps-extraInfo24' },
      { id: 'cps-productSlider25', infoPanel: 'cps-extraInfo25' }
    ];

    productSliders.forEach((sliderItem) => {
      const slider = document.getElementById(sliderItem.id);
      const infoPanel = document.getElementById(sliderItem.infoPanel);

      if (!slider) return;

      const wrapper = slider.closest('.cps-slider-wrapper');
      const leftBtn = wrapper.querySelector('.cps-nav-left');
      const rightBtn = wrapper.querySelector('.cps-nav-right');
      const slides = slider.querySelectorAll('.cps-slide');

      let scrollAmount = 0;

      function getSlideWidth() {
        return slider.firstElementChild?.offsetWidth + 15 || 300;
      }

      function autoScroll() {
        scrollAmount += getSlideWidth();
        if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
          scrollAmount = 0;
        }
        slider.scrollTo({ left: scrollAmount, behavior: 'smooth' });

        // Optional: Do something with the infoPanel (e.g., update active product info)
        // Example:
        // if (infoPanel) {
        //   infoPanel.textContent = `Scrolling... (Position: ${scrollAmount})`;
        // }
      }

      // Manual Navigation
      leftBtn?.addEventListener('click', () => {
        scrollAmount = Math.max(0, slider.scrollLeft - getSlideWidth());
        slider.scrollTo({ left: scrollAmount, behavior: 'smooth' });
      });

      rightBtn?.addEventListener('click', () => {
        scrollAmount = Math.min(slider.scrollWidth, slider.scrollLeft + getSlideWidth());
        slider.scrollTo({ left: scrollAmount, behavior: 'smooth' });
      });

      // Auto scroll every 4 seconds
      setInterval(autoScroll, 4000);

      // Reset scroll position on resize
      window.addEventListener('resize', () => {
        scrollAmount = slider.scrollLeft;
      });
    });
  });

  // theme.js
    (function () {
        class CustomSlider {
            constructor(container) {
                this.container = container;
                this.track =
                container.querySelector('.slider-track') || container.querySelector('.swiper-wrapper');
                this.slides = Array.from(this.track.querySelectorAll('.swiper-slide'));
                this.prevBtn = container.querySelector('.swiper-button-prev');
                this.nextBtn = container.querySelector('.swiper-button-next');
                this.currentIndex = 0;
                this.isDragging = false;
                this.startX = 0;
                this.scrollLeft = 0;
                this.autoSlideInterval = null;
                this.slidesPerView = this.calculateSlidesPerView();
                this.gap = this.calculateGap();

                this.init();
            }

            calculateSlidesPerView() {
                const container = this.container;
                const isMobile = window.innerWidth <= 768; // Mobile breakpoint

                // ================= MOBILE CONFIG =================
                if (isMobile) {
                    // 1. Recently Viewed - 1 slide (new requirement)
                    if (container.closest('.recently-viewed-swiper')) return 1;

                    // 2. Circle Categories - 2 slides
                    if (container.closest('.product-circle')) return 2;

                    // 3. Apple Products - 1 slide
                    if (container.closest('.apple-best-products')) return 1;

                    // 4. Blog Swiper - 1.2 slides (peek effect)
                    if (container.closest('.blog-swiper')) return 1.2;

                    // 5. All other product cards - 2 slides
                    if (container.closest('.bes-tab-swiper') ||
                        container.closest('.bes-product-slider') ||
                        container.closest('.mySwiper-products-games') ||
                        container.closest('.mySwiper-products-all') ||
                        container.closest('.wearables-slider') ||
                        container.closest('.mySwiper-products-mobile') ||
                        container.closest('.mySwiper-products-speakers') ||
                        container.closest('.products-slider')) {
                        return 2;
                    }
                    if (this.container.closest('.slider-half-container')) return 2;
                    // Default mobile fallback
                    return 2;
                }

                // ================= DESKTOP CONFIG =================
                if (container.closest('.blog-swiper')) return 3;
                if (container.closest('.product-circle')) return 6;

                if (container.closest('.bes-tab-swiper') ||
                    container.closest('.bes-product-slider') ||
                    container.closest('.Apple-Best-Products') ||
                    container.closest('.mySwiper-products-all') ||
                    container.closest('.mySwiper-products-games') ||
                    container.closest('.mySwiper-products-all')) {
                    return 5;
                }

                if (container.closest('.mySwiper-products-mobile')) return 4;
                if (container.closest('.wearables-slider')) return 5;
                if (container.closest('.mySwiper-products-speakers')) return 4;
                if (container.closest('.recently-viewed-swiper')) return 4; // Desktop: 4 slides

                if (container.closest('.products-slider')) return 5;

                return 4; // Desktop default
            }

            calculateGap() {
                if (this.slides.length > 1) {
                    const style = window.getComputedStyle(this.slides[0]);
                    return parseInt(style.marginRight) || 16;
                }
                return 16;
            }

            init() {
                this.updateSlideWidth();

                if (this.prevBtn) {
                    this.prevBtn.addEventListener('click', () => this.prev());
                    this.prevBtn.classList.toggle('swiper-button-disabled', this.currentIndex <= 0);
                }

                if (this.nextBtn) {
                    this.nextBtn.addEventListener('click', () => this.next());
                    this.nextBtn.classList.toggle('swiper-button-disabled', this.currentIndex >= this.getMaxIndex());
                }

                this.track.addEventListener('touchstart', (e) => this.touchStart(e));
                this.track.addEventListener('touchmove', (e) => this.touchMove(e));
                this.track.addEventListener('touchend', () => this.touchEnd());

                window.addEventListener('resize', () => {
                    this.updateSlideWidth();
                    this.updatePosition(true);
                    this.updateNavigation();
                });

                if (this.container.classList.contains('auto-slide')) {
                    this.startAutoSlide();
                }
            }

            getMaxIndex() {
                return Math.max(0, this.slides.length - this.slidesPerView);
            }

            updateSlideWidth() {
                if (this.slides.length > 0) {
                    const containerWidth = this.container.offsetWidth;
                    this.slideWidth = (containerWidth - ((this.slidesPerView - 1) * this.gap)) / this.slidesPerView;

                    this.slides.forEach(slide => {
                        slide.style.width = `${this.slideWidth}px`;
                        slide.style.flexShrink = '0';
                    });
                }
            }

            updateNavigation() {
                if (!this.prevBtn || !this.nextBtn) return;

                this.prevBtn.classList.toggle('swiper-button-disabled', this.currentIndex <= 0);
                this.nextBtn.classList.toggle('swiper-button-disabled', this.currentIndex >= this.getMaxIndex());
            }

            prev() {
                if (this.currentIndex > 0) {
                    this.currentIndex--;
                    this.updatePosition();
                    this.updateNavigation();
                }
                this.resetAutoSlide();
            }

            next() {
                if (this.currentIndex < this.getMaxIndex()) {
                    this.currentIndex++;
                    this.updatePosition();
                    this.updateNavigation();
                }
                this.resetAutoSlide();
            }

            updatePosition(instant = false) {
                const offset = -this.currentIndex * (this.slideWidth + this.gap);
                this.track.style.transition = instant ? 'none' : 'transform 0.5s ease';
                this.track.style.transform = `translateX(${offset}px)`;
            }

            touchStart(e) {
                this.isDragging = true;
                this.startX = e.touches[0].pageX;
                this.scrollLeft = this.currentIndex * (this.slideWidth + this.gap);
                this.track.style.transition = 'none';
                this.pauseAutoSlide();
            }

            touchMove(e) {
                if (!this.isDragging) return;
                e.preventDefault();
                const x = e.touches[0].pageX;
                const walk = (x - this.startX) * 1.5;
                this.track.style.transform = `translateX(${-this.scrollLeft + walk}px)`;
            }

            touchEnd() {
                this.isDragging = false;
                const threshold = this.slideWidth / 3;
                const currentTransform = window.getComputedStyle(this.track).getPropertyValue('transform');
                const matrix = new DOMMatrix(currentTransform);
                const diff = matrix.m41 + this.scrollLeft;

                if (diff > threshold && this.currentIndex > 0) {
                    this.prev();
                } else if (diff < -threshold && this.currentIndex < this.getMaxIndex()) {
                    this.next();
                } else {
                    this.updatePosition();
                }

                this.startAutoSlide();
            }

            startAutoSlide() {
                if (this.container.classList.contains('auto-slide')) {
                    this.autoSlideInterval = setInterval(() => this.next(), 3000);
                }
            }

            pauseAutoSlide() {
                clearInterval(this.autoSlideInterval);
            }

            resetAutoSlide() {
                this.pauseAutoSlide();
                this.startAutoSlide();
            }
        }

        function initBlogSlider() {
            const blogSlider = document.querySelector('.blog-swiper');
            if (!blogSlider) return;

            // Ensure proper structure exists
            let wrapper = blogSlider.querySelector('.swiper-wrapper');
            if (!wrapper) {
                wrapper = document.createElement('div');
                wrapper.className = 'swiper-wrapper slider-track';
                while (blogSlider.firstChild) {
                    wrapper.appendChild(blogSlider.firstChild);
                }
                blogSlider.appendChild(wrapper);
            } else {
                wrapper.classList.add('slider-track');
            }

            // Create navigation buttons if they don't exist
            if (!blogSlider.querySelector('.swiper-button-prev')) {
                const prevBtn = document.createElement('div');
                prevBtn.className = 'swiper-button-prev';
                prevBtn.innerHTML = '❮';
                blogSlider.appendChild(prevBtn);

                const nextBtn = document.createElement('div');
                nextBtn.className = 'swiper-button-next';
                nextBtn.innerHTML = '❯';
                blogSlider.appendChild(nextBtn);
            }

            // Add slider-container class if needed
            blogSlider.classList.add('slider-container');

            // Initialize slider
            new CustomSlider(blogSlider);
        }

        function initRecentlyViewedSlider() {
            const recentSlider = document.querySelector('.recently-viewed-swiper');
            if (!recentSlider) return;

            // Convert to proper slider structure
            const wrapper = recentSlider.querySelector('.swiper-wrapper') || recentSlider;
            wrapper.classList.add('slider-track');

            // Create container if needed
            if (!recentSlider.classList.contains('slider-container')) {
                const container = document.createElement('div');
                container.className = 'slider-container';
                container.innerHTML = recentSlider.innerHTML;

                // Add navigation buttons
                container.innerHTML += `
        <div class="swiper-button-prev">❮</div>
        <div class="swiper-button-next">❯</div>
      `;

                recentSlider.replaceWith(container);
                new CustomSlider(container);
            } else {
                new CustomSlider(recentSlider);
            }
        }

   function initHorizontalSlider() {
    const slider = document.querySelector('.product-card-horizontal-slider');
    if (!slider) return;

    const prevBtn = document.querySelector('.product-card-horizontal-nav.prev');
    const nextBtn = document.querySelector('.product-card-horizontal-nav.next');

    if (!prevBtn || !nextBtn) return;

    const gap = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--card-gap')) || 16;
    let currentIndex = 0;
    let autoSlideInterval;
    let direction = 1; // 1 = forward, -1 = backward

    const slides = document.querySelectorAll('.product-card-horizontal-slide');
    if (!slides.length) return;

    // Limit to 15 slides for auto-slide and navigation
    const maxSlides = 15;
    const totalSlides = Math.min(slides.length, maxSlides);
    const slideWidth = slides[0].offsetWidth;
    const container = slider.parentElement;
    const containerWidth = container.offsetWidth;
    const visibleSlides = Math.floor(containerWidth / (slideWidth + gap));
    const maxIndex = Math.max(0, totalSlides - visibleSlides);

    function goToSlide(index) {
        currentIndex = Math.max(0, Math.min(index, maxIndex));
        slider.style.transition = 'transform 0.5s ease';
        slider.style.transform = `translateX(-${currentIndex * (slideWidth + gap)}px)`;
        updateNavigation();
    }

    function updateNavigation() {
        prevBtn.disabled = currentIndex <= 0;
        nextBtn.disabled = currentIndex >= maxIndex;
        prevBtn.classList.toggle('swiper-button-disabled', currentIndex <= 0);
        nextBtn.classList.toggle('swiper-button-disabled', currentIndex >= maxIndex);
    }

    prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) goToSlide(currentIndex - 1);
        resetAutoSlide();
    });

    nextBtn.addEventListener('click', () => {
        if (currentIndex < maxIndex) goToSlide(currentIndex + 1);
        resetAutoSlide();
    });

    function startAutoSlide() {
        autoSlideInterval = setInterval(() => {
            if (direction === 1) {
                if (currentIndex < maxIndex) {
                    goToSlide(currentIndex + 1);
                } else {
                    // Reached end - reverse direction
                    direction = -1;
                    goToSlide(currentIndex - 1);
                }
            } else {
                if (currentIndex > 0) {
                    goToSlide(currentIndex - 1);
                } else {
                    // Reached start - reverse direction
                    direction = 1;
                    goToSlide(currentIndex + 1);
                }
            }
        }, 3000);
    }

    function resetAutoSlide() {
        clearInterval(autoSlideInterval);
        startAutoSlide();
    }

    // Initialize
    updateNavigation();
    startAutoSlide();

    // Pause on hover
    slider.addEventListener('mouseenter', () => clearInterval(autoSlideInterval));
    slider.addEventListener('mouseleave', startAutoSlide);
}

        function initProductFunctionality() {
            function updateCartNavbar() {
                fetch('/cart.js')
                    .then(res => res.json())
                    .then(cart => {
                        document.querySelectorAll('.cart-badge').forEach(el => el.textContent = cart.item_count);
                        document.querySelectorAll('.cart-text').forEach(el => el.textContent = 'Rs ' + (cart.total_price / 100).toFixed(0));
                    })
                    .catch(err => console.error('Error updating cart:', err));
            }

            function openQuickView(product) {
                document.getElementById('quickViewImage').src = product.image;
                document.getElementById('quickViewTitle').textContent = product.title;
                document.getElementById('quickViewPrice').textContent = product.price;
                document.getElementById('quickViewModal').classList.remove('hidden');
            }

            function closeQuickView() {
                document.getElementById('quickViewModal').classList.add('hidden');
            }

            function addToCart() {
                alert('Product added to cart!');
                closeQuickView();
            }

            const RATING_STORAGE_KEY = 'product_rating_data';
            const RATING_VALIDITY_DAYS = 3;

            function generateRatingData() {
                const ratings = {};
                document.querySelectorAll('.rating').forEach((el, i) => ratings[i] = Math.random() < 0.5 ? 4 : 5);
                const data = { timestamp: Date.now(), ratings };
                localStorage.setItem(RATING_STORAGE_KEY, JSON.stringify(data));
                return data;
            }

            function getRatingData() {
                const stored = localStorage.getItem(RATING_STORAGE_KEY);
                if (stored) {
                    const data = JSON.parse(stored);
                    if (Date.now() - data.timestamp < RATING_VALIDITY_DAYS * 24 * 60 * 60 * 1000) return data;
                    localStorage.removeItem(RATING_STORAGE_KEY);
                }
                return generateRatingData();
            }

            function applyRatings() {
                const data = getRatingData();
                document.querySelectorAll('.rating').forEach((el, i) => {
                    const stars = el.querySelectorAll('i');
                    stars.forEach((star, idx) => star.classList.toggle('fa-solid', idx < data.ratings[i]));
                });
            }

            function initProductCards() {
                document.querySelectorAll('.cps-quick-view-btn').forEach(btn => {
                    btn.addEventListener('click', () => {
                        openQuickView({
                            image: btn.dataset.image,
                            title: btn.dataset.title,
                            price: btn.dataset.price
                        });
                    });
                });

                document.querySelectorAll('.cps-product-card').forEach(card => {
                    const mainImage = card.querySelector('.main-image');
                    const zones = card.querySelectorAll('.hover-zone');
                    if (!mainImage || !zones.length) return;

                    const defaultSrc = mainImage.src;
                    zones.forEach((zone, i) => zone.addEventListener('mouseenter', () => {
                        mainImage.style.opacity = 0;
                        setTimeout(() => {
                            mainImage.src = zone.dataset.img;
                            mainImage.style.opacity = 1;
                        }, 200);
                        card.querySelectorAll('.cps-tab').forEach(t => t.classList.remove('active'));
                        card.querySelectorAll('.cps-tab')[i].classList.add('active');
                    }));

                    card.querySelector('.cps-product-image').addEventListener('mouseleave', () => {
                        mainImage.style.opacity = 0;
                        setTimeout(() => {
                            mainImage.src = defaultSrc;
                            mainImage.style.opacity = 1;
                        }, 200);
                        card.querySelectorAll('.cps-tab').forEach(t => t.classList.remove('active'));
                        card.querySelectorAll('.cps-tab')[0].classList.add('active');
                    });
                });
            }

            function initTooltips() {
                document.querySelectorAll('.share-icon').forEach(icon => {
                    const wrapper = icon.closest('.share-tooltip-wrapper');
                    wrapper.addEventListener('mouseenter', () =>
                        wrapper.querySelector('.share-tooltip').style.display = 'block');
                    wrapper.addEventListener('mouseleave', () =>
                        wrapper.querySelector('.share-tooltip').style.display = 'none');
                });
            }

            function formatAuthorNames() {
                document.querySelectorAll('.author-name').forEach(el => {
                    el.textContent = el.textContent.trim().split(' ')[0];
                });
            }

            function setupEventDelegation() {
                document.addEventListener('click', event => {
                    const tgt = event.target.closest('span');
                    if (!tgt) return;

                    if (tgt.classList.contains('add-to-cart-btn')) {
                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: tgt.dataset.variantId,
                                quantity: 1
                            })
                        })
                            .then(r => r.json())
                            .then(data => {
                                alert('Added!');
                                updateCartNavbar();
                            })
                            .catch(e => alert('Error'));
                    }
                });
            }

            applyRatings();
            initProductCards();
            initTooltips();
            formatAuthorNames();
            setupEventDelegation();
        }

        function randomizeAllSliders() {
            document.querySelectorAll('.slider-track').forEach(track => {
                const slides = Array.from(track.children);
                if (slides.length <= 1) return;

                for (let i = slides.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [slides[i], slides[j]] = [slides[j], slides[i]];
                }

                track.innerHTML = '';
                slides.forEach(s => track.appendChild(s));
            });
        }

        function initBuyElectroTabs() {
            const section = document.querySelector('.bes-product-slider');
            if (!section) return;

            const buttons = section.querySelectorAll('.bes-tab-button');
            const panes = section.querySelectorAll('.bes-tab-pane');

            buttons.forEach(btn => {
                btn.addEventListener('click', function () {
                    const target = this.getAttribute('data-tab');

                    buttons.forEach(b => b.classList.remove('bes-active'));
                    this.classList.add('bes-active');

                    panes.forEach(p => {
                        if (p.id === target) {
                            p.classList.add('bes-active');
                            p.style.display = '';
                            const sliderContainer = p.querySelector('.slider-container');
                            if (sliderContainer && !sliderContainer._sliderInitialized) {
                                new CustomSlider(sliderContainer);
                                sliderContainer._sliderInitialized = true;
                            }
                        } else {
                            p.classList.remove('bes-active');
                            p.style.display = 'none';
                        }
                    });
                });
            });
        }

    function initWearablesTabs() {
    const section = document.querySelector('.wearables-slider');
    if (!section) return;

    const buttons = section.querySelectorAll('.tab-button');
    const panes = section.querySelectorAll('.tab-pane');

    // Initialize all sliders on load
    panes.forEach(pane => {
        if (pane.classList.contains('active')) {
            const slider = pane.querySelector('.cps-slider');
            if (slider && !slider._initialized) {
                initializeWearableSlider(slider);
            }
        }
    });

    buttons.forEach(btn => {
        btn.addEventListener('click', function() {
            const target = this.getAttribute('data-tab');

            // Update active button
            buttons.forEach(b => b.classList.remove('active'));
            this.classList.add('active');

            // Update panes visibility
            panes.forEach(p => {
                if (p.id === target) {
                    p.classList.add('active');
                    
                    // Initialize slider for this pane if not already done
                    const slider = p.querySelector('.cps-slider');
                    if (slider && !slider._initialized) {
                        initializeWearableSlider(slider);
                    }
                } else {
                    p.classList.remove('active');
                }
            });
        });
    });
}

function initializeWearableSlider(slider) {
    const infoPanelId = slider.id + '-info';
    const infoPanel = document.getElementById(infoPanelId);
    const container = slider.closest('.cps-slider-container');
    
    if (!infoPanel) {
        console.error('Info panel not found for slider:', slider.id);
        return;
    }

    let hoverTimeout;

    // Initialize hover functionality for product cards
    slider.querySelectorAll('.cps-product-card').forEach(card => {
        card.addEventListener('mouseenter', function() {
            clearTimeout(hoverTimeout);
            const info = this.getAttribute('data-extra');
            if (!info) {
                console.warn('Missing data-extra attribute on product card:', this);
                return;
            }
            
            const cardRect = this.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            
            infoPanel.style.left = `${cardRect.left - containerRect.left}px`;
            infoPanel.style.width = `${this.offsetWidth}px`;
            infoPanel.innerHTML = info;
            infoPanel.style.display = 'block';
        });

        card.addEventListener('mouseleave', function(e) {
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && relatedTarget.closest('.cps-extra-info-panel') === infoPanel) return;
            hoverTimeout = setTimeout(() => infoPanel.style.display = 'none', 150);
        });
    });

    infoPanel.addEventListener('mouseenter', () => clearTimeout(hoverTimeout));
    infoPanel.addEventListener('mouseleave', () => infoPanel.style.display = 'none');

    // Initialize slider navigation
    const wrapper = slider.closest('.cps-slider-wrapper');
    const prevBtn = wrapper?.querySelector('.cps-nav-left');
    const nextBtn = wrapper?.querySelector('.cps-nav-right');

    function getScrollAmount() {
        const firstCard = slider.querySelector('.cps-product-card');
        if (!firstCard) return slider.offsetWidth;
        return firstCard.offsetWidth + parseInt(window.getComputedStyle(slider).gap);
    }

    function scrollSlider(direction) {
        const scrollAmount = getScrollAmount();
        let targetScroll = slider.scrollLeft + (direction === 'next' ? scrollAmount : -scrollAmount);
        if (direction === 'next' && targetScroll + slider.offsetWidth >= slider.scrollWidth - 50) {
            targetScroll = 0;
        }
        slider.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => scrollSlider('prev'));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollSlider('next'));

    // Initialize auto-scroll
    let autoScrollInterval;
    const autoScrollDelay = 5000;

    function startAutoScroll() {
        autoScrollInterval = setInterval(() => scrollSlider('next'), autoScrollDelay);
    }

    function stopAutoScroll() {
        clearInterval(autoScrollInterval);
    }

    slider.addEventListener('mouseenter', stopAutoScroll);
    slider.addEventListener('mouseleave', startAutoScroll);
    slider.addEventListener('touchstart', stopAutoScroll);
    slider.addEventListener('touchend', startAutoScroll);

    startAutoScroll();

    // Mark as initialized
    slider._initialized = true;
}

        document.addEventListener('DOMContentLoaded', () => {
            // Initialize blog slider first to ensure proper setup
            initBlogSlider();

            // Then initialize all other sliders
            document.querySelectorAll('.slider-container').forEach(container => {
                if (!container._sliderInitialized) {
                    new CustomSlider(container);
                    container._sliderInitialized = true;
                }
            });

            document.querySelectorAll('[data-tab]').forEach(tab => {
                tab.addEventListener('click', function () {
                    const pane = document.getElementById(this.getAttribute('data-tab'));
                    const sc = pane.querySelector('.slider-container');
                    if (sc && !sc._sliderInitialized) {
                        new CustomSlider(sc);
                        sc._sliderInitialized = true;
                    }
                });
            });

            const firstPane = document.querySelector('.tab-pane.active, .bes-tab-pane.active');
            if (firstPane) {
                const sc = firstPane.querySelector('.slider-container');
                if (sc && !sc._sliderInitialized) {
                    new CustomSlider(sc);
                    sc._sliderInitialized = true;
                }
            }

            initRecentlyViewedSlider();
            initHorizontalSlider();
            initProductFunctionality();
            randomizeAllSliders();
            initBuyElectroTabs();
            initWearablesTabs();
        });
    })();
   

    // ========== MAIN SLIDER INITIALIZATION ==========
   

document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.brand-slider-container');
  
  sliders.forEach(container => {
    const slider = container.querySelector('.brand-slider');
    const prevBtn = container.querySelector('.slider-nav.prev');
    const nextBtn = container.querySelector('.slider-nav.next');
    const deviceType = container.dataset.device;
    
    // Initialize slider if enough items
    if (slider.children.length > (deviceType === 'mobile' ? 4 : 6)) {
      let isDown = false;
      let startX;
      let scrollLeft;
      
      // Mouse/touch events for dragging
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      
      slider.addEventListener('mouseleave', () => {
        isDown = false;
      });
      
      slider.addEventListener('mouseup', () => {
        isDown = false;
      });
      
      slider.addEventListener('mousemove', (e) => {
        if(!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });
      
      // Navigation buttons
      prevBtn.addEventListener('click', () => {
        slider.scrollBy({
          left: -200,
          behavior: 'smooth'
        });
      });
      
      nextBtn.addEventListener('click', () => {
        slider.scrollBy({
          left: 200,
          behavior: 'smooth'
        });
      });
      
      // Show/hide nav buttons based on scroll position
      function updateNavButtons() {
        prevBtn.style.display = slider.scrollLeft > 0 ? 'block' : 'none';
        nextBtn.style.display = slider.scrollLeft < (slider.scrollWidth - slider.clientWidth) ? 'block' : 'none';
      }
      
      slider.addEventListener('scroll', updateNavButtons);
      updateNavButtons();
    }
  });
});